const initialState = {
  isLoading: false,
  data: [],
  mySlugs: [],
  error: false,
  errorMessage: null,
  errorCode: '',
};

const mutationFailedState = (state, action) => ({
  ...state,
  isLoading: false,
  error: true,
  errorMessage: action.payload.response.data.error,
  errorCode: action.payload.response.status,
});

const mutationBeganState = (state) => ({
  ...state,
  isLoading: true,
  error: false,
  errorMessage: null,
  errorCode: '',
});

// Redux reducer contract: (state, action) with state defaulted.
// eslint-disable-next-line default-param-last
export default (state = initialState, action) => {
  switch (action.type) {
    case 'BEGIN_GET_ALL_TEAMS': {
      return {
        ...state,
        isLoading: true,
        error: false,
      };
    }
    case 'FAILED_GET_ALL_TEAMS': {
      return {
        ...state,
        isLoading: false,
        error: true,
      };
    }
    case 'FINISHED_GET_ALL_TEAMS': {
      return {
        ...state,
        isLoading: false,
        error: false,
        data: action.payload.data.teams || [],
        mySlugs: action.payload.data.my_team_slugs || [],
      };
    }
    case 'BEGIN_CREATE_TEAM':
    case 'BEGIN_UPDATE_TEAM':
    case 'BEGIN_DELETE_TEAM': {
      return mutationBeganState(state);
    }
    case 'FAILED_CREATE_TEAM':
    case 'FAILED_UPDATE_TEAM':
    case 'FAILED_DELETE_TEAM': {
      return mutationFailedState(state, action);
    }
    case 'FINISHED_CREATE_TEAM':
    case 'FINISHED_UPDATE_TEAM':
    case 'FINISHED_DELETE_TEAM': {
      return {
        ...state,
        isLoading: false,
        error: false,
      };
    }
    default:
      return state;
  }
};
